import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const SalaryProject = ({
  size,
  type,
  theme,
  className,
  dataTestId = "salary-project-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.668 3.672c0-.737.597-1.334 1.333-1.334h9.997c.736 0 1.333.597 1.333 1.334v1.323h.294c.736 0 1.333.597 1.333 1.333v6c0 .737-.597 1.333-1.333 1.333H1.375a1.333 1.333 0 0 1-1.333-1.333v-6c0-.736.597-1.333 1.333-1.333h.293V3.672Zm11.33 0v1.323H3V3.672h9.997ZM6.25 6.328H1.375v6h4.884c-.793-.694-1.262-1.839-1.262-3.004 0-1.16.466-2.301 1.253-2.996Zm3.5 0c.788.695 1.254 1.835 1.254 2.996 0 1.165-.47 2.31-1.262 3.004h4.883v-6H9.75ZM6.33 9.324c0-1.458.895-2.34 1.67-2.34.776 0 1.67.882 1.67 2.34 0 1.459-.894 2.34-1.67 2.34-.775 0-1.67-.881-1.67-2.34Z"
    />
  </SVGIcon>
);
